<template lang='pug'>
  button.base.icon-only.component( :type='type' :title='title' )
    slot
</template>

<script>
  export default {
		name: 'base.icon-only.button.component',
		
    props: {
      type: { type: String, default: 'button' },
      title: { type: String, default: 'Button' }
    }
  }
</script>

<style scoped lang='stylus'>
	button
		color rgb( 64 64 64 )
		cursor pointer
	
	button:hover
		transform scale(1.1)
		transform-origin center
</style>
